import { Stack } from '@mui/material';
import { useFormContext, useWatch } from 'react-hook-form';
import { FormTextField } from 'src/components/Forms/FormTextField/form-text-field';
import {
  BLOCK_LONG_TEXTAREA_PROPS,
  BLOCK_TEXT_FIELD_PROPS,
} from 'src/pages/Settings/memberships/components/landing-page-tab/block-fields/field-props';
import { MediaFields } from 'src/pages/Settings/memberships/components/landing-page-tab/block-fields/media-fields';
import { SegmentedToggleField } from 'src/pages/Settings/memberships/components/landing-page-tab/segmented-toggle-field';
import {
  blockFieldName,
  type LandingPageFormValues,
  MEDIA_POSITION_OPTIONS,
} from 'src/pages/Settings/memberships/components/landing-page-tab/types';

interface ContentBlockFieldsProps {
  index: number;
  readOnly: boolean;
}

export const ContentBlockFields = ({ index, readOnly }: ContentBlockFieldsProps) => {
  const { control } = useFormContext<LandingPageFormValues>();
  const mediaKind = useWatch({ control, name: blockFieldName(index, 'contentMediaKind') });

  return (
    <Stack gap={2.5}>
      <FormTextField
        type="textfield"
        name={blockFieldName(index, 'contentKicker')}
        label="Kicker"
        disabled={readOnly}
        textFieldProps={BLOCK_TEXT_FIELD_PROPS}
      />

      <FormTextField
        type="textfield"
        name={blockFieldName(index, 'contentTitle')}
        label="Title"
        required="Title is required"
        disabled={readOnly}
        textFieldProps={BLOCK_TEXT_FIELD_PROPS}
      />

      <FormTextField
        type="textfield"
        name={blockFieldName(index, 'contentBody')}
        label="Body"
        disabled={readOnly}
        textFieldProps={BLOCK_LONG_TEXTAREA_PROPS}
      />

      <MediaFields index={index} prefix="content" readOnly={readOnly} />

      {mediaKind === 'none' ? null : (
        <SegmentedToggleField
          name={blockFieldName(index, 'contentMediaPosition')}
          label="Media position"
          options={MEDIA_POSITION_OPTIONS}
          readOnly={readOnly}
        />
      )}
    </Stack>
  );
};
